// extracted by mini-css-extract-plugin
export var copyableField = "_og-4";
export var customerBadge = "_og-0";
export var customerInfoTitle = "_og-2";
export var details = "_og-1";
export var dropdownContainer = "_og-5";
export var dropdownImage = "_og-6";
export var editAssigneeForm = "_og-a";
export var editButton = "_og-3";
export var email = "_og-7";
export var hidden = "_og-d";
export var input = "_og-8";
export var saveButton = "_og-b";
export var shopifyIcon = "_og-c";
export var suggestionBadge = "_og-e";
export var suggestionText = "_og-f";
export var username = "_og-9";